import { CoverSlide, SplitSlide, CardsSlide, PillarsSlide } from "./Core";
import {
  ServicesSlide,
  StepsSlide,
  NumbersSlide,
  SectorsSlide,
  GallerySlide,
  MetricsSlide,
  ContactSlide,
} from "./Showcase";

export function renderSlide(slide, opts = {}) {
  const props = { slide, isPrint: !!opts.isPrint, onNext: opts.onNext };
  switch (slide.layout) {
    case "cover":
      return <CoverSlide {...props} />;
    case "split":
      return <SplitSlide {...props} />;
    case "cards":
      return <CardsSlide {...props} />;
    case "pillars":
      return <PillarsSlide {...props} />;
    case "services":
      return <ServicesSlide {...props} />;
    case "steps":
      return <StepsSlide {...props} />;
    case "numbers":
      return <NumbersSlide {...props} />;
    case "sectors":
      return <SectorsSlide {...props} />;
    case "gallery":
      return <GallerySlide {...props} />;
    case "metrics":
      return <MetricsSlide {...props} />;
    case "contact":
      return <ContactSlide {...props} />;
    default:
      return <SplitSlide {...props} />;
  }
}
